import {Injectable} from '@angular/core';

import {BehaviorSubject} from 'rxjs';

import {Alert} from '../models/alert';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  alert$ = new BehaviorSubject<Alert | null>(null);

  onAlert(alert: Alert): void {
    this.alert$.next(alert);
  }

  close(): void {
    this.alert$.next(null);
  }
}
